<template>
  <b-container fluid class="bv-example-row bv-example-row-flex-cols" :style="Object.assign(getContainerStyle, bgStyle)">
    <stage-row
      :pageId="pageId"
      :zoom="zoom"
      :btnId="layoutOption.buttonContextUid"
      v-for="row in layoutOption.rows"
      :key="row.uid"
      :id="row.uid"
      :rowData="row"
      @contextmenuHandle="contextmenuHandle"
    />
  </b-container>
</template>

<script>
// import row from './rows.vue'
export default {
  props: {
    zoom: {
      type: Number,
      default: 1
    },
    layoutOption: {
      type: Object,
      required: true
    },
    pageId: {
      type: String
    }
  },
  // components: {
  //   row
  // },
  computed: {
    // layoutOption() {
    //   return this.$store.state[this.request_prefix].page.layoutOption
    // },
    getContainerStyle() {
      return { height: "100%", width: "100%", paddingLeft: "0", paddingRight: "0" }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      if (!this.layoutOption.background || !Array.isArray(this.layoutOption.background)) {
        return {}
      }
      this.layoutOption.background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            containerBg.backgroundColor = bg.isThemeColor
              ? this.$store.state[this.request_prefix].page.themeColor
              : bg.color
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
            }
            break
          default:
        }
      })
      return containerBg
    }
  },
  methods: {
    contextmenuHandle(e) {
      this.$emit("contextmenuHandle", e)
    }
  }
}
</script>

<style scoped>
.stage_layout {
  width: 100%;
  height: 100%;
}
.box {
  width: 100%;
  height: 100%;
  background-color: white;
}
</style>
